import * as React from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { Home, ArrowLeft, Search } from "lucide-react"

function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="text-center space-y-6">
        <div className="flex justify-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-[hsl(var(--bg-hover))]">
            <span className="text-[48px] font-bold text-[hsl(var(--text-muted))]">404</span>
          </div>
        </div>
        <div className="space-y-2">
          <h1 className="text-[24px] font-bold text-[hsl(var(--text-primary))]">
            Page Not Found
          </h1>
          <p className="text-[14px] text-[hsl(var(--text-secondary))] max-w-md">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        <div className="flex items-center justify-center gap-3">
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>
          <Button onClick={() => navigate("/")}>
            <Home className="mr-2 h-4 w-4" />
            Dashboard
          </Button>
        </div>
      </div>
    </div>
  )
}

export default NotFoundPage
